import { Component, signal, ViewChild, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { SwiperDirective } from '../../../shared/directive/swiper.directive';
import { DoctorService } from '../Services/doctor.service';
import { DoctorModel } from '../Model/doctor.model';
import { RouterLink } from '@angular/router';
import { SharedModule } from './../../../shared/Module/shared.module';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-doctor-slider',
  imports: [SwiperDirective, TranslateModule, RouterLink, SharedModule, CommonModule],
  templateUrl: './doctor-slider.component.html',
  styleUrls: ['./doctor-slider.component.css']
})
export class DoctorSliderComponent {

  doctors = signal<DoctorModel[]>([]);
  private subs = new Subscription();   // container for all subscriptions

  private doctorService = inject(DoctorService)

  ngOnInit(): void {
    this.loadData();
  }

  public swiperOptions = signal({
    slidesPerView: 4,
    spaceBetween: 30,
    slidesPerGroup: 1,
    loop: true,
    loopFillGroupWithBlank: true,
    centeredSlides: false,
    pagination: {
      el: ".swiper-pagination",
      // type: "fraction",
      type: "bullets",
      clickable: true,

    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 3000,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      1500: {
        slidesPerView: 4,
      },
      1300: {
        slidesPerView: 4,
      },
      991: {
        slidesPerView: 3,

      },
      767: {
        slidesPerView: 3,
      },
      575: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      }
    }
  })

  loadData(): void {
    const sub = this.doctorService.getAll().subscribe({
      next: (data) => {
        this.doctors.set(
          data.value.sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
        );
      },
      error: (err) => {
        console.error('Error loading sliders:', err);
      }
    });
    this.subs.add(sub);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();   // unsubscribe from all
  }

}
